import React from 'react';
import styled from 'styled-components';
import SEO from 'components/common/SEO';
import orgByIdQuery from 'ApolloClient/Queries/orgById';
import { graphql, compose } from 'react-apollo';
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import clientSignup from 'ApolloClient/Mutations/clientSignup';
import ClientInviteForm from 'components/forms/ClientInviteForm';
import Result from 'components/common/Result';

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
const PageContainer = styled.div`
  min-height: 100%;
  background: ${p => p.theme.background};
`;

const LogoImg = styled.img`
  max-width: 100%;
  width: auto;
  max-height: 100%;
  margin-bottom: 5px;
`;

const LogoContainer = styled.div`
  height: 75px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = ({ image }) => {
  if (image) {
    return (
      <LogoContainer>
        <LogoImg src={image} />
      </LogoContainer>
    );
  }
  return null;
};

export const CantFindStudio = () => (
  <PageContainer>
    <ContentContainer>
      <Result
        type="error"
        title="We can't find this studio..."
        description="Can you double check with the studio your link is correct?"
      />
    </ContentContainer>
  </PageContainer>
);

class ClientInviteRoute extends React.PureComponent {
  state = {
    submitted: false,
    loading: false,
  };

  handleSubmit = async params => {
    let variables = {
      params: {
        organizationId: this.props.match.params._id,
        ...params,
      },
    };

    let res;
    this.setState({ loading: true });
    try {
      res = await this.props.clientSignup({ variables });
    } catch (err) {
      return console.log(err);
    }
    this.setState({ submitted: true, loading: false });
    console.log(res);
  };

  render() {
    if (!this.props.orgByIdQuery.orgById) {
      return <CantFindStudio />;
    }

    let { title, image, contactForm } = this.props.orgByIdQuery.orgById;

    return (
      <PageContainer>
        <SEO title={`${title} - Onboard Form`} image={image} />

        <ContentContainer>
          <div style={{ maxWidth: '100%' }}>
            {image && <Logo image={image} />}
            {!image && (
              <div style={{ height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: 24 }}>{title}</div>
              </div>
            )}
            {!this.state.submitted ? (
              <ClientInviteForm
                organization={this.props.orgByIdQuery.orgById}
                contactForm={contactForm}
                loading={this.state.loading}
                handleSubmit={this.handleSubmit}
              />
            ) : (
              <Result
                type="success"
                title="We got your submission!"
                description="Somebody will be in touch with you shortly..."
              />
            )}
          </div>
        </ContentContainer>
      </PageContainer>
    );
  }
}

let options = ({ match }) => ({
  variables: {
    _id: match.params._id,
  },
});

export default compose(
  graphql(clientSignup, { name: 'clientSignup' }),
  graphql(orgByIdQuery, { options, name: 'orgByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'orgByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'orgByIdQuery' }),
)(ClientInviteRoute);



// WEBPACK FOOTER //
// ./src/routes/client-invite/index.js